import React, { useEffect, useState } from "react";
import {
  Button, CircularProgress, Dialog, DialogActions, DialogContent,
  DialogTitle, makeStyles, TextField, Typography,
} from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { green } from "@material-ui/core/colors";
import api from "../../services/api";
import toastError from "../../errors/toastError";

const useStyles = makeStyles(theme => ({
  btnWrapper: { position: "relative" },
  buttonProgress: {
    color: green[500],
    position: "absolute",
    top: "50%", left: "50%",
    marginTop: -12, marginLeft: -12,
  },
  field: { marginBottom: theme.spacing(2) },
  hint: { color: "#888", fontSize: "0.8rem", marginBottom: theme.spacing(1) },
}));

const CloseTicketModal = ({ open, onClose, ticket, onConfirm, loading }) => {
  const classes = useStyles();
  const [notes, setNotes] = useState("");
  const [clients, setClients] = useState([]);
  const [selectedClient, setSelectedClient] = useState(null);
  const [loadingClients, setLoadingClients] = useState(false);

  useEffect(() => {
    if (!open) return;
    setNotes("");
    setSelectedClient(null);

    setLoadingClients(true);
    api.get("/clients").then(({ data }) => {
      const list = Array.isArray(data) ? data : (data.clients || []);
      setClients(list);
      if (ticket?.contact?.clientId) {
        const preselected = list.find(c => c.id === ticket.contact.clientId);
        if (preselected) setSelectedClient(preselected);
      }
      setLoadingClients(false);
    }).catch(err => { toastError(err); setLoadingClients(false); });
  }, [open]);

  const handleConfirm = () => {
    onConfirm({ notes, clientId: selectedClient?.id ?? null });
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Concluir atendimento #{ticket?.id}</DialogTitle>
      <DialogContent dividers>
        <div className={classes.field}>
          <Autocomplete
            options={clients}
            getOptionLabel={c => `${c.name}${c.sccmCode ? ` (${c.sccmCode})` : ""}`}
            value={selectedClient}
            onChange={(_, val) => setSelectedClient(val)}
            loading={loadingClients}
            renderInput={params => (
              <TextField
                {...params}
                label="Cliente (opcional)"
                variant="outlined"
                size="small"
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <>
                      {loadingClients ? <CircularProgress size={16} /> : null}
                      {params.InputProps.endAdornment}
                    </>
                  ),
                }}
              />
            )}
          />
          <Typography className={classes.hint}>
            {selectedClient
              ? `Cliente selecionado: ${selectedClient.name}`
              : "Sem contrato? Deixe em branco."}
          </Typography>
        </div>
        <TextField
          label="Observações do atendimento"
          value={notes}
          onChange={e => setNotes(e.target.value)}
          variant="outlined"
          multiline
          rows={4}
          fullWidth
          placeholder="Descreva o que foi realizado..."
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary" disabled={loading}>
          Cancelar
        </Button>
        <div className={classes.btnWrapper}>
          <Button
            onClick={handleConfirm}
            color="primary"
            variant="contained"
            disabled={loading}
          >
            Concluir
          </Button>
          {loading && <CircularProgress size={24} className={classes.buttonProgress} />}
        </div>
      </DialogActions>
    </Dialog>
  );
};

export default CloseTicketModal;
